import React, { FunctionComponent, memo } from 'react';
import { meetingBoardsPageSelectors } from '../../../../app/page/page-storage/meeting-boards/meeting-boards.selectors';
import { useSelect } from '../../../../utils/selector.utils';
import { BoardsWidget } from '../../common/widgets/BoardsWidget';

import { IBoardsProps } from './types';

export const Boards: FunctionComponent<IBoardsProps> = memo(({ meetingId }) => {
  const meetingBoard = useSelect(meetingBoardsPageSelectors.selectMeetingBoards)[meetingId];

  return !!meetingBoard && <BoardsWidget meetingBoard={meetingBoard} isAdmin={true} meetingId={meetingId} />;
});
